import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { TaxonomyTerm, TaxonomyTermsByType, TaxonomyType } from 'bookraw/shared/models/taxonomy.model';
import { map } from 'rxjs/operators';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable()
export class TaxonomyTermsService extends ListService<TaxonomyTerm> {

  url: string = '/api/admin/terms';

  terms$ = new ReplaySubject<TaxonomyTermsByType>(1);

  /**
   * A taxonomy termeket az összes lekért termből vesszük, mert az tartalmazza a child taxonómiákat is.
   */
  private static filterTerms(terms: TaxonomyTermsByType, termIds: number[], type: TaxonomyType) {
    const allTerms = terms[type] ?? [];
    return allTerms.filter(term => termIds.includes(term.id));
  }

  /**
   * A taxonomy termeket az összes lekért termből vesszük, mert az tartalmazza a child taxonómiákat is.
   */
  private static findTerm(terms: TaxonomyTermsByType, termIds: number[], type: TaxonomyType) {
    const allTerms = terms[type] ?? [];
    return allTerms.find(term => termIds.includes(term.id));
  }

  /**
   * Taxonómiák lekérése child taxonómiákkal együtt
   *
   * *Ezt elegendő lenne egyszer lekérdezni szűrés nélkül, de egyelőre megmarad a régi működés, hogy ne kelljen külön
   * kezelni a lista frissítését
   */
  fetchTaxonomies() {
    this.getTaxonomies(true).subscribe(terms => this.terms$.next(terms));
  }

  /**
   * Taxonómiák kigyüjtése tipus szerint
   */
  getTaxonomies(withDescendants = false): Observable<TaxonomyTermsByType> {
    return super.getList().pipe(
      map(response => response.result.list.reduce((r, term) => {
        if (withDescendants) {
          // Az összes parenthez is beállítjuk a termet, hogyy kiválasztható legyen
          for (let taxonomy = term.taxonomy; taxonomy; taxonomy = taxonomy.parent) {
            r[taxonomy.id] = [...r[taxonomy.id] || [], term];
          }
        } else {
          // Csak az aktuális taxonómia termjeit állítjuk be
          r[term.taxonomyId] = [...r[term.taxonomyId] || [], term];
        }
        return r;
      }, {})),
      map(taxonomyTerms => {
        // Ha kaptunk Topic taxonomyTermeket, ABC sorrendbe rendezzük őket
        if (taxonomyTerms[TaxonomyType.TOPIC]) {
          taxonomyTerms[TaxonomyType.TOPIC].sort((a, b) => a.title.localeCompare(b.title))
        }
        if (taxonomyTerms[TaxonomyType.LEVEL]) {
          taxonomyTerms[TaxonomyType.LEVEL].sort((a, b) => (+a.title > +b.title) ? 1 : -1)
        }
        return taxonomyTerms;
      })
    );
  }

  mapTerms(termIds: number[], setter: (
    filterTerms: (type: TaxonomyType) => TaxonomyTerm[],
    findTerm: (type: TaxonomyType) => TaxonomyTerm,
    allTerms: TaxonomyTermsByType) => void) {
    this.terms$.subscribe(terms => {
      setter(
        (type: TaxonomyType) => TaxonomyTermsService.filterTerms(terms, termIds, type),
        (type: TaxonomyType) => TaxonomyTermsService.findTerm(terms, termIds, type),
        terms
      );
    });
  }
}
